import { render } from "./Phonenum.vue?vue&type=template&id=25114f44&scoped=true"
import script from "./Phonenum.vue?vue&type=script&lang=js"
export * from "./Phonenum.vue?vue&type=script&lang=js"

import "./Phonenum.vue?vue&type=style&index=0&id=25114f44&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25114f44"

export default script